import type { CameraDeviceStatus } from '../types/camera-status';
import { notifyCameraThumbnail } from './camera-thumbnail-watch';

/**
 * Camera-specific reactions to an incoming device status, from any source (a socket
 * push or the bulk status load).
 *
 * @remarks
 * A status without `c_thumbnail` is ignored
 *
 * @param deviceId - The device the status belongs to.
 * @param status - The status object being stored.
 */
export const handleCameraStatusUpdate = (deviceId: string, status?: CameraDeviceStatus): void => {
	if (!status?.c_thumbnail) {
		return;
	}
	notifyCameraThumbnail(deviceId, status?.c_thumbnail);
};
